import { useState, type ReactNode } from "react";
import { AudienceTag, Button } from "@omnabase/ui";
import { FORM_LIMITS } from "@omnabase/shared";

/** The editing column's header (builder v2, the founder's design; questions 1 to 3): the form's name, renamed in place ("Rename form" opens
 *  the box "Form name", Enter or leaving it closes it), and the tools at the end: on a narrow screen a "Preview" jump to the preview below, and
 *  "+ Field". The name is the team's own label for the form (the text blocks round: visitors read the form's Text blocks, a new form's first
 *  block holding the name); it belongs to the draft: Save sends it, Cancel puts it back. Readers see the name as text. (The founder removed
 *  the line "Draft · 6 fields" on 2026-10-25.) */
export function BuilderHead({ name, problem, edit, onName, tools }: {
  name: string; /** the name's problem, when there is one */ problem: string | null; edit: boolean; onName: (name: string) => void; tools: ReactNode;
}) {
  const [renaming, setRenaming] = useState(false);
  return (
    <header className="ob-form-builder__head">
      <div className="ob-form-builder__head-main">
        <div className="ob-form-builder__title-row">
          {renaming
            ? <input className="ob-form-builder__name-input" aria-label="Form name" value={name} maxLength={FORM_LIMITS.name} autoFocus onChange={(e) => onName(e.target.value)}
                onBlur={() => setRenaming(false)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === "Escape") { e.preventDefault(); setRenaming(false); } }} />
            : <h1 className="ob-form-builder__name">{name.trim() || "Untitled form"}</h1>}
          {edit && !renaming && <Button variant="icon" size="sm" icon="pen" aria-label="Rename form" title="The team's name for the form; visitors read its Text blocks" onClick={() => setRenaming(true)} />}
          <AudienceTag audience="locked" />
        </div>
        {problem && <p className="ob-form-builder__problem" role="alert">{problem}</p>}
      </div>
      <div className="ob-form-builder__head-tools">{tools}</div>
    </header>
  );
}
